/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {InvoiceDtoIEnumerableSuccessDataResult} from '../models/InvoiceDtoIEnumerableSuccessDataResult'
import type {PaymentMethodCreateDto} from '../models/PaymentMethodCreateDto'
import type {PaymentMethodDtoIEnumerableSuccessDataResult} from '../models/PaymentMethodDtoIEnumerableSuccessDataResult'
import type {PaymentMethodDtoSuccessDataResult} from '../models/PaymentMethodDtoSuccessDataResult'
import type {StringSuccessDataResult} from '../models/StringSuccessDataResult'
import type {SuccessResult} from '../models/SuccessResult'

import type {CancelablePromise} from '../core/CancelablePromise'
import {OpenAPICouponCenter, PaymentMethodDto} from 'rest'
import {request as __request} from '../core/request'
import {StripeProductDto} from 'rest/models/StripeProductDto'
import {PaginatedResult} from 'rest/types/PaginatedResult'
import {CouponCenterTransaction} from 'rest/types/CouponCenterTransaction'

export class PaymentService {
  /**
   * @returns PaymentMethodDtoSuccessDataResult Success
   * @throws ApiError
   */
  public static postApiUnsubscribe(payload: {
    status: string
  }): CancelablePromise<PaymentMethodDtoSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'POST',
      url: '/api/v1/stripe-update-subscription/',
      body: {
        status: payload.status,
      },
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param merchantId
   * @returns PaymentMethodDtoIEnumerableSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiPaymentGet(): CancelablePromise<Array<PaymentMethodDto>> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/v1/payment-methods/',
      transformResponse: results => {
        const final = []

        results.map(element => {
          const mapped = {
            created: element.created_at,
            isDefault: element.is_default,
            card: {
              brand: '',
              country: '',
              last4: '',
              expMonth: element.exp_month,
              expYear: element.exp_year,
            },
          }

          final.push(mapped)
        })
        return final
      },
      query: {},
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @returns PaymentMethodDtoIEnumerableSuccessDataResult Success
   * @throws ApiError
   */
  public static getSubscriptionProducts(): CancelablePromise<
    Array<StripeProductDto>
  > {
    const clientId = process.env.REACT_APP_CLIENT_ID

    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/v1/coupon-center-plans/',
      transformResponse: results => {
        const products: StripeProductDto[] = []

        results.map((element: Record<string, any>) => {
          const product = {
            id: element.id,
            updated: element.updated,
            price: {
              currency: element.price.currency,
              unit_amount: element.price.unit_amount,
            },
            name: element.name,
            payment_link: {
              url: element.payment_link.url,
            },
          }

          products.push(product)
        })
        return products
      },
      query: {
        client: clientId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @returns PaginatedResult<CouponCenterTransaction> Success
   * @throws ApiError
   */
  public static getTransactions(): CancelablePromise<
    PaginatedResult<CouponCenterTransaction>
  > {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/v1/coupon-center-transactions/',
      query: {},
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param paymentMethodId
   * @returns SuccessResult Success
   * @throws ApiError
   */
  public static deleteApiPaymentDelete(
    paymentMethodId?: string
  ): CancelablePromise<SuccessResult> {
    return __request(OpenAPICouponCenter, {
      method: 'DELETE',
      url: '/api/Payment/Delete',
      query: {
        paymentMethodId: paymentMethodId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param merchantId
   * @returns InvoiceDtoIEnumerableSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiPaymentGetInvoices(
    merchantId?: number
  ): CancelablePromise<InvoiceDtoIEnumerableSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Payment/GetInvoices',
      query: {
        merchantId: merchantId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param merchantId
   * @param paymentMethod
   * @returns SuccessResult Success
   * @throws ApiError
   */
  public static postApiPaymentSetDefaultMethod(
    merchantId?: number,
    paymentMethod?: string
  ): CancelablePromise<SuccessResult> {
    return __request(OpenAPICouponCenter, {
      method: 'POST',
      url: '/api/Payment/SetDefaultMethod',
      query: {
        merchantId: merchantId,
        paymentMethod: paymentMethod,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param merchantId
   * @param returnUrl
   * @returns StringSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiPaymentSession(
    merchantId?: number,
    returnUrl?: string
  ): CancelablePromise<StringSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Payment/Session',
      query: {
        merchantId: merchantId,
        returnUrl: returnUrl,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }
}
